// import React from 'react';

// const ListSelection = ({
//   labelText = '',
//   items = [],
//   selectedItems = [],
//   handleItemSelection,
//   handleSelectAll,
// }) => {
//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
//       <label style={{ marginBottom: '5px' }}>{labelText}</label>
//       <button
//         type="button"
//         className="btn"
//         onClick={handleSelectAll}
//         style={{ marginBottom: '10px', alignSelf: 'start' }}
//       >
//         בחר/בטל הכל
//       </button>
      
//       <div
//         className="checkbox-group"
//         style={{
//           maxHeight: '200px',
//           overflowY: 'auto',
//           border: '1px solid #ccc',
//           borderRadius: '5px',
//           padding: '10px',
//         }}
//       >
//         {items.map((item) => (
//           <label key={item.id || item} style={{ display: 'block', marginBottom: '5px' }}>
//             <input
//               type="checkbox"
//               value={item.id || item}
//               checked={selectedItems.includes(item.id || item)}
//               onChange={() => handleItemSelection(item.id || item)}
//             />
//             {item.name || item}
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ListSelection;


import React from 'react';

const ListSelection = ({
  labelText = '',
  items = [],
  selectedItems = [],
  handleItemSelection,
  handleSelectAll,
}) => {
  const isAllSelected = selectedItems.length === items.length;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
      {handleSelectAll && (
        <button
          type="button"
          className="btn"
          onClick={handleSelectAll}
          style={{ marginBottom: '10px', alignSelf: 'start' }}
        >
          {isAllSelected ? 'בטל הכל' : 'בחר הכל'}
        </button>
      )}

      <div
        className="checkbox-group"
        style={{
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '10px',
        }}
      >
        {items.map((item) => {
          const itemId = typeof item === 'object' ? item.id : item; // Use id for objects or the value itself for strings
          const itemLabel = typeof item === 'object' ? item.label : item; // Use label for objects or the value itself for strings

          return (
            <label key={itemId} style={{ display: 'block', marginBottom: '5px' }}>
              <input
                type="checkbox"
                value={itemId}
                checked={selectedItems.includes(itemId)} // Match by id or string
                onChange={() => handleItemSelection(itemId)} // Pass id or string to handler
              />
              {itemLabel} {/* Display label or the string value */}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default ListSelection;
